import React, {Suspense} from 'react';
import PropTypes from 'prop-types';
import Corsi from "../../../views/Corsi/Corsi";
import {Route, Routes, useLocation} from "react-router-dom";
import {Loading} from "../../../components/index";
import SceltaProfiloContainer from "./SceltaProfilo";
import Corso from "../../../views/Corso/Corso";
import {RUOLI} from "../../../applicationConf";
import {useSelector} from "react-redux";
import {SuperAdminRoutes} from "../../../views/SuperAdmin/SuperAdminRoutes";
import {Info} from "./Info";
import Profilo from '../../../views/Profilo/Profilo';


const InserimentoAnagrafiche = React.lazy(() => import('../../../views/Anagrafiche/InserimentoAnagraficheContainer'));


const RecuperaDati = (props) => {

    const location = useLocation();

    const profiliDisponibili = useSelector(state => state.auth.profiliDisponibili);
    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);
    const error = useSelector(state => state.auth.errori);
    const userCf = useSelector(state => state.auth.user && state.auth.user.USER_CF);

    const returnContentCondition = () => {
            if (profiliDisponibili != null && profiliDisponibili.length > 1 && !ruoloScelto) {
                return (
                    <SceltaProfiloContainer
                        profiliDisponibili={profiliDisponibili}
                        chooseRole={props.chooseRole}/>
                )
            } else if (ruoloScelto != null && typeof ruoloScelto === 'string') {
                const CONFIGURATION_RUOLO = RUOLI[ruoloScelto.toUpperCase()] != null ? RUOLI[ruoloScelto.toUpperCase()] : {};

                return (
                    <>
                        <Routes>
                            <Route path="corsi" element={<Corsi/>}/>
                            <Route path='corso/:id/*' element={<Corso/>}/>
                            <Route path='profilo' element={<Profilo/>}/>

                            {CONFIGURATION_RUOLO.HEADER.map(link => link.LINK).includes('/inserimentoAnagrafica') && (
                                <Route path="/inserimentoAnagrafica" name="inserimentoAnagrafica"
                                       element={
                                           <Suspense fallback={<Loading messaggio='Recupero dati...'/>}>
                                               <InserimentoAnagrafiche {...props}/>
                                           </Suspense>}/>
                            )}

                            {CONFIGURATION_RUOLO.hasOwnProperty("SUPER_ADMIN") && (SuperAdminRoutes(CONFIGURATION_RUOLO, userCf))}

                        </Routes>
                        {location.pathname === '/' && <Info/>}
                    </>
                )
            } else if (ruoloScelto != null && typeof ruoloScelto === 'object') {
                return (<div className='text-muted h-50 w-100 mx-auto py-5 text-center justify-content-center'>
                    <h4>
                        Attenzione! utente non censito contattare l'amministratore di sistema
                    </h4>
                </div>)
            } else if (error != null && !ruoloScelto) {
                return (
                    <div className='text-muted h-50 w-100 mx-auto py-5 text-center justify-content-center'>
                        <h4>
                            Attenzione! {typeof error === 'string' ? error : error.message} contattare l'amministratore
                            di sistema
                        </h4>
                    </div>
                )
            } else {
                return (<Loading messaggio={'In attesa dei dati utente. Attendere prego'}/>)
            }
        }
    ;

    return (
        <div data-test="component-recuperaDati">
            {returnContentCondition()}
        </div>
    );

};

RecuperaDati.propTypes =
    {
        chooseRole: PropTypes.func
    }
;

export default RecuperaDati;

